'use es6';

import * as React from 'react';
import { List, Map as ImmutableMap } from 'immutable';
import invariant from 'react-utils/invariant';
import { jsx as _jsx } from "react/jsx-runtime";
const partial = (fn, ...bound) => (...args) => fn(...[...bound, ...args]);
function withPartials(Component) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this._partials = ImmutableMap();
      this.partial = (func, ...args) => {
        invariant(typeof func === 'function', '%s.partial: expected `func` to be a function but got `%s`.', this.constructor.displayName, func);
        const keyList = List.of(func, ...args);
        if (!this._partials.has(keyList)) {
          this._partials = this._partials.set(keyList, partial(func, ...args));
        }
        return this._partials.get(keyList);
      };
    }
    componentWillUnmount() {
      this._partials = null;
    }
    render() {
      return /*#__PURE__*/_jsx(Component, Object.assign({
        partial: this.partial
      }, this.props));
    }
  };
}
export default withPartials;